import React from 'react'
import { Helmet } from 'react-helmet'
import { connect } from 'react-redux'
import { getUser } from '@/store/getters'

export const Scripts = ( props ) => {
  if( process.env.NODE_ENV === 'development' ) return null
  const { user : { user } } = props

  return (
    <Helmet>
    </Helmet>
  )
}

const mapStateToProps = ( state ) => {
  const user = getUser( state )
  return { user }
}

export default connect( mapStateToProps )( Scripts )



// WEBPACK FOOTER //
// ./src/components/Scripts.js